import React from 'react';

export const Star = () => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_96_2986)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.66264 0.592447L4.11389 3.92245L0.416385 4.3987C0.344852 4.40764 0.277412 4.43701 0.22214 4.48329C0.166869 4.52957 0.126109 4.5908 0.104742 4.65965C0.0833742 4.7285 0.0823051 4.80205 0.101662 4.87149C0.121019 4.94094 0.159982 5.00333 0.213885 5.0512L2.95139 7.51495L2.21264 11.2087C2.19872 11.2793 2.20542 11.3525 2.23195 11.4194C2.25847 11.4863 2.30369 11.5442 2.36221 11.5861C2.42073 11.628 2.49007 11.6522 2.56196 11.6557C2.63385 11.6593 2.70525 11.6421 2.76764 11.6062L6.00014 9.7312L9.23639 11.6062C9.29877 11.6421 9.37017 11.6593 9.44206 11.6557C9.51395 11.6522 9.5833 11.628 9.64181 11.5861C9.70033 11.5442 9.74555 11.4863 9.77207 11.4194C9.7986 11.3525 9.8053 11.2793 9.79139 11.2087L9.05264 7.51495L11.7901 5.0512C11.843 5.00288 11.8808 4.94045 11.8993 4.87128C11.9178 4.80212 11.9161 4.72911 11.8944 4.66089C11.8727 4.59267 11.8319 4.53208 11.7769 4.48628C11.7219 4.44048 11.6549 4.41139 11.5839 4.40245L7.88639 3.92245L6.34139 0.592447C6.31156 0.526976 6.26352 0.471468 6.20302 0.432545C6.14251 0.393621 6.07208 0.372925 6.00014 0.372925C5.92819 0.372925 5.85776 0.393621 5.79726 0.432545C5.73675 0.471468 5.68871 0.526976 5.65889 0.592447H5.66264Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_96_2986'>
          <rect width='12' height='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
